import { Col, Row } from 'antd';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import React from 'react';

interface IStatementWrapper {
    pageTitle: string;
    pageInfoText?: string;
    pageInfoTextBold?: string;
    pageInfoTextBold2?: string;
}

const StatementWrapper: React.FC<IStatementWrapper> = ({
    children,
    pageTitle,
    pageInfoText,
    pageInfoTextBold,
    pageInfoTextBold2
}) => {
    return (
        <>
            <Row className="statement-wrapper">
                <Col span={24}>
                    <div>
                        {pageTitle ? <Title text={pageTitle} level={1} /> : ''}
                        {pageInfoText ? (
                            <div>
                                <Paragraph text={pageInfoText} /> <br />
                            </div>
                        ) : (
                            ''
                        )}
                        {pageInfoTextBold ? (
                            <div>
                                <Paragraph
                                    text={pageInfoTextBold}
                                    style={{
                                        paddingTop: 8,
                                        fontWeight: 'bold'
                                    }}
                                />
                                <br />
                            </div>
                        ) : (
                            ''
                        )}
                        {pageInfoTextBold2 ? (
                            <Paragraph
                                text={pageInfoTextBold2}
                                style={{
                                    fontWeight: 'bold'
                                }}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </Col>
                <Col span={24}>{children}</Col>
            </Row>
        </>
    );
};

export default StatementWrapper;
